// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OdVC","title":"Header_title__maVKo","left":"Header_left__2BXfv","clinicName":"Header_clinicName__2x_OC"};